'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var cid = require('multiformats/cid');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default =
/*#__PURE__*/
_interopDefaultLegacy(errCode);

function normaliseInput(_x) {
  return _normaliseInput.apply(this, arguments);
}

function _normaliseInput() {
  _normaliseInput = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(input) {
    var cid$1, iterator, first, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _cid, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, obj, _iterator5, _first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _cid2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, _obj;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            cid$1 = cid.CID.asCID(input);

            if (!cid$1) {
              _context.next = 7;
              break;
            }

            _context.next = 6;
            return toPin({
              cid: cid$1
            });

          case 6:
            return _context.abrupt("return");

          case 7:
            if (!(input instanceof String || typeof input === 'string')) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return toPin({
              path: input
            });

          case 10:
            return _context.abrupt("return");

          case 11:
            if (!(input.cid != null || input.path != null)) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return toPin(input);

          case 14:
            return _context.abrupt("return", _context.sent);

          case 15:
            if (!(Symbol.iterator in input)) {
              _context.next = 81;
              break;
            }

            iterator = input[Symbol.iterator]();
            first = iterator.next();

            if (!first.done) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return", iterator);

          case 20:
            if (!(cid.CID.asCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
              _context.next = 50;
              break;
            }

            _context.next = 23;
            return toPin({
              cid: first.value
            });

          case 23:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context.prev = 26;
            _iterator3 = iterator[Symbol.iterator]();

          case 28:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              _context.next = 35;
              break;
            }

            _cid = _step3.value;
            _context.next = 32;
            return toPin({
              cid: _cid
            });

          case 32:
            _iteratorNormalCompletion3 = true;
            _context.next = 28;
            break;

          case 35:
            _context.next = 41;
            break;

          case 37:
            _context.prev = 37;
            _context.t0 = _context["catch"](26);
            _didIteratorError3 = true;
            _iteratorError3 = _context.t0;

          case 41:
            _context.prev = 41;
            _context.prev = 42;

            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }

          case 44:
            _context.prev = 44;

            if (!_didIteratorError3) {
              _context.next = 47;
              break;
            }

            throw _iteratorError3;

          case 47:
            return _context.finish(44);

          case 48:
            return _context.finish(41);

          case 49:
            return _context.abrupt("return");

          case 50:
            if (!(first.value.cid != null || first.value.path != null)) {
              _context.next = 80;
              break;
            }

            _context.next = 53;
            return toPin(first.value);

          case 53:
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 56;
            _iterator4 = iterator[Symbol.iterator]();

          case 58:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              _context.next = 65;
              break;
            }

            obj = _step4.value;
            _context.next = 62;
            return toPin(obj);

          case 62:
            _iteratorNormalCompletion4 = true;
            _context.next = 58;
            break;

          case 65:
            _context.next = 71;
            break;

          case 67:
            _context.prev = 67;
            _context.t1 = _context["catch"](56);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t1;

          case 71:
            _context.prev = 71;
            _context.prev = 72;

            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }

          case 74:
            _context.prev = 74;

            if (!_didIteratorError4) {
              _context.next = 77;
              break;
            }

            throw _iteratorError4;

          case 77:
            return _context.finish(74);

          case 78:
            return _context.finish(71);

          case 79:
            return _context.abrupt("return");

          case 80:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 81:
            if (!(Symbol.asyncIterator in input)) {
              _context.next = 165;
              break;
            }

            _iterator5 = input[Symbol.asyncIterator]();
            _context.next = 85;
            return _awaitAsyncGenerator(_iterator5.next());

          case 85:
            _first = _context.sent;

            if (!_first.done) {
              _context.next = 88;
              break;
            }

            return _context.abrupt("return", _iterator5);

          case 88:
            if (!(cid.CID.asCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
              _context.next = 126;
              break;
            }

            _context.next = 91;
            return toPin({
              cid: _first.value
            });

          case 91:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 93;
            _iterator = _asyncIterator(_iterator5);

          case 95:
            _context.next = 97;
            return _awaitAsyncGenerator(_iterator.next());

          case 97:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 101;
            return _awaitAsyncGenerator(_step.value);

          case 101:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 109;
              break;
            }

            _cid2 = _value;
            _context.next = 106;
            return toPin({
              cid: _cid2
            });

          case 106:
            _iteratorNormalCompletion = true;
            _context.next = 95;
            break;

          case 109:
            _context.next = 115;
            break;

          case 111:
            _context.prev = 111;
            _context.t2 = _context["catch"](93);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 115:
            _context.prev = 115;
            _context.prev = 116;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 120;
              break;
            }

            _context.next = 120;
            return _awaitAsyncGenerator(_iterator.return());

          case 120:
            _context.prev = 120;

            if (!_didIteratorError) {
              _context.next = 123;
              break;
            }

            throw _iteratorError;

          case 123:
            return _context.finish(120);

          case 124:
            return _context.finish(115);

          case 125:
            return _context.abrupt("return");

          case 126:
            if (!(_first.value.cid != null || _first.value.path != null)) {
              _context.next = 164;
              break;
            }

            _context.next = 129;
            return toPin(_first.value);

          case 129:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context.prev = 131;
            _iterator2 = _asyncIterator(_iterator5);

          case 133:
            _context.next = 135;
            return _awaitAsyncGenerator(_iterator2.next());

          case 135:
            _step2 = _context.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context.next = 139;
            return _awaitAsyncGenerator(_step2.value);

          case 139:
            _value2 = _context.sent;

            if (_iteratorNormalCompletion2) {
              _context.next = 147;
              break;
            }

            _obj = _value2;
            _context.next = 144;
            return toPin(_obj);

          case 144:
            _iteratorNormalCompletion2 = true;
            _context.next = 133;
            break;

          case 147:
            _context.next = 153;
            break;

          case 149:
            _context.prev = 149;
            _context.t3 = _context["catch"](131);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 153:
            _context.prev = 153;
            _context.prev = 154;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context.next = 158;
              break;
            }

            _context.next = 158;
            return _awaitAsyncGenerator(_iterator2.return());

          case 158:
            _context.prev = 158;

            if (!_didIteratorError2) {
              _context.next = 161;
              break;
            }

            throw _iteratorError2;

          case 161:
            return _context.finish(158);

          case 162:
            return _context.finish(153);

          case 163:
            return _context.abrupt("return");

          case 164:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 165:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 166:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[26, 37, 41, 49], [42,, 44, 48], [56, 67, 71, 79], [72,, 74, 78], [93, 111, 115, 125], [116,, 120, 124], [131, 149, 153, 163], [154,, 158, 162]]);
  }));
  return _normaliseInput.apply(this, arguments);
}

function toPin(input) {
  var path = input.cid || "".concat(input.path);

  if (!path) {
    throw errCode__default["default"](new Error('Unexpected input: Please path either a CID or an IPFS path'), 'ERR_UNEXPECTED_INPUT');
  }

  var pin = {
    path: path,
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}

exports.normaliseInput = normaliseInput;